import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";

let sectionDetails = {
  title: "We would love to hear from you",
  description:
    "Write to us or call us anytime to share your queries, suggestions, feedback, or anything else.",
};

export default function ContactUsHeading() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-gray-50 overflow-hidden py-10 md:py-16",
        innerContainerStyles: "max-w-7xl mx-auto px-4 lg:px-6 xl:px-0",
      }}
    >
      <Heading
        title={sectionDetails.title}
        description={sectionDetails.description}
      />
    </SectionContainerBase>
  );
}

const Heading = (props: any) => {
  return (
    <IconTitleDescriptionActionCard
      title={props.title}
      description={props.description}
      itemTitleDescriptionCardBaseClasses={{
        titleWrapper: "text-left",
        titleStyles:
          "text-3xl font-extrabold text-gray-900 md:leading-none md:tracking-tight md:text-4xl",
        descriptionWrapper: "text-left mt-4",
        descriptionStyles: "max-w-xl text-base text-gray-500",
      }}
    />
  );
};
